import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import '../../assets/css/keyboard-shortcuts.css';
var isMac = window.navigator.platform.indexOf('Win') < 0 ? true : false;
var controlKey = isMac ? '⌘' : 'CTRL';
var KeyboardShortcuts = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(KeyboardShortcuts, _React$PureComponent);
  var _super = _createSuper(KeyboardShortcuts);
  function KeyboardShortcuts() {
    var _this;
    _classCallCheck(this, KeyboardShortcuts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderShortcut = function (keys) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "keyboard-shortcut"
      }, keys.map(function (key, index) {
        return /*#__PURE__*/React.createElement("kbd", {
          key: index
        }, key);
      })), /*#__PURE__*/React.createElement("br", null));
    };
    _this.renderContainer = function (keys, description) {
      return /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, _this.renderShortcut(keys)), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, description));
    };
    return _this;
  }
  _createClass(KeyboardShortcuts, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        t = _this$props.t,
        toggleShortcutDialog = _this$props.toggleShortcutDialog,
        userHelp = _this$props.userHelp;
      var userHelpData = userHelp.userHelpData;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        toggle: toggleShortcutDialog,
        className: "keyboard-shortcut-dialog",
        zIndex: 1071
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: toggleShortcutDialog
      }, /*#__PURE__*/React.createElement("span", {
        className: "mr-2"
      }, t(userHelp.title))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[1]['shortcutType'])), this.renderContainer(['#', 'space'], t(userHelpData[1].shortcutData['Heading_1'])), this.renderContainer(['##', 'space'], t(userHelpData[1].shortcutData['Heading_2'])), this.renderContainer(['###', 'space'], t(userHelpData[1].shortcutData['Heading_3'])), this.renderContainer(['####', 'space'], t(userHelpData[1].shortcutData['Heading_4'])), this.renderContainer(['#####', 'space'], t(userHelpData[1].shortcutData['Heading_5'])), this.renderContainer(['######', 'space'], t(userHelpData[1].shortcutData['Heading_6']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[0]['shortcutType'])), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['*', 'space']), this.renderShortcut(['-', 'space'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[0].shortcutData['Make_list']))), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['1.', 'space'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[0].shortcutData['Make_ordered_list']))), this.renderContainer(['Tab'], t(userHelpData[0].shortcutData['Increase_depth'])), this.renderContainer(['Shift', 'Enter'], t(userHelpData[0].shortcutData['Insert_child_in_item'])), this.renderContainer(['Enter'], t(userHelpData[0].shortcutData['Insert_new_item']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[6]['shortcutType'])), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['**bold**', 'space']), this.renderShortcut(['__bold__', 'space'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[6].shortcutData['Bold']))), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['*italic*', 'space']), this.renderShortcut(['_italic_', 'space'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[6].shortcutData['Italic']))), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['***italic***', 'space']), this.renderShortcut(['___italic___', 'space'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[6].shortcutData['Italic_Bold']))), this.renderContainer(['`code`', 'space'], t(userHelpData[6].shortcutData['Inline_code']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[2]['shortcutType'])), /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, this.renderShortcut(['```']), this.renderShortcut(['space*4'])), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, t(userHelpData[2].shortcutData['Make_code_block']))), this.renderContainer(['Tab'], t(userHelpData[2].shortcutData['Insert_indent'])), this.renderContainer(['Enter'], t(userHelpData[2].shortcutData['Insert_new_line'])), this.renderContainer([controlKey, 'Enter'], t(userHelpData[2].shortcutData['Escape_code_block']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[3]['shortcutType'])), this.renderContainer(['>', 'space'], t(userHelpData[3].shortcutData['Make_Block_quote'])), this.renderContainer(['Enter'], t(userHelpData[3].shortcutData['Escape_Block_quote']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[4]['shortcutType'])), this.renderContainer(['Enter'], t(userHelpData[4].shortcutData['Insert_Table_Row'])), this.renderContainer([controlKey, 'Enter'], t(userHelpData[4].shortcutData['Escape_table']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[7]['shortcutType'])), this.renderContainer([controlKey, 's'], t(userHelpData[7].shortcutData['Save_file']))), /*#__PURE__*/React.createElement("div", {
        className: "pb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyboard-shortcut-title pb-1"
      }, t(userHelpData[8]['shortcutType'])), this.renderContainer([controlKey, 'v'], t(userHelpData[8].shortcutData['Paste_screen_shot']))))));
    }
  }]);
  return KeyboardShortcuts;
}(React.PureComponent);
export default withTranslation('dtable')(KeyboardShortcuts);